import { render } from "./CustomizationSummaryItem.vue?vue&type=template&id=7f4a90f3"
import script from "./CustomizationSummaryItem.vue?vue&type=script&lang=js"
export * from "./CustomizationSummaryItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__